import React from "react";
import {
    DataGrid,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useLicenses } from '../../hooks/useLicenses';
import {
    createLicenseActivationColumn,
    createLicenseDurationColumn,
    createLicenseExpirationColumn,
    createLicenseStatusColumn,
    licenseTableInitialState,
} from '../licensing/licenseTableColumns';

function LicenseTab (){
    const currentCompany = useSelector((state) => state.CompanyReducer?.userCompanies[0]);
    const { data: licensesData = [] } = useLicenses({
        companyId: currentCompany?.id,
        type: '1',
        enabled: Boolean(currentCompany?.id),
    });

    const licenseReadableData = [];
    licensesData?.forEach(licensePusher);
    function licensePusher(licensesData) {
        licenseReadableData.push({
            id: licensesData.id,
            licenseNumber: licensesData.licenseNumber,
            used: licensesData.used,
            userId: licensesData.userId,
            licenseUserName: `${licensesData.userFN} ${licensesData.userLN}`,
            licenseCreated: licensesData.licenseCreated,
            licenseUpdated: licensesData.licenseUpdated,
            licenseExpiration: licensesData.licenseExpiration,
            licenseActivation: licensesData.licenseActivation,
            notes: licensesData.notes,
            revoked: licensesData.revoked,
        });
    };

    const columns = [
        { field: 'licenseNumber', headerName: 'License #', width: 300, headerClassName: 'header' },
        createLicenseStatusColumn(),
        { field: 'licenseUserName', headerName: 'User', width: 175, headerClassName: 'header',
            renderCell: (cellValues) => {
                if(cellValues.row.licenseUserName == `null null`){
                    return(
                        <p>N/A</p>
                    )
                } else {
                    return(
                        <p>{cellValues.row.licenseUserName}</p>
                    )
                }
            }
        },
        { field: 'licenseCreated', headerName: 'Generated Date', width: 125, headerClassName: 'header',
            renderCell: (params) => {
            let date = new Date(params.row.licenseCreated);
            const options = {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              };
            return date.toLocaleString("en-US",options)
        }},
        createLicenseActivationColumn(),
        createLicenseExpirationColumn(),
        createLicenseDurationColumn(),
    ];

    const rows = licenseReadableData;

    return(
        <div>
            <h4>License History</h4>
            <DataGrid
                editMode="row"
                style={{textAlign:'left', height: '70vh'}}
                columns={columns}
                rows={rows}
                initialState={licenseTableInitialState}
            />
        </div>
    )
};

export default LicenseTab;
